export type ManualNotAFitReasonCategory =
  | "credential_review"
  | "administrative_block";

/**
 * T2-6943: Hold is a temporary credential review; Block is a deliberate
 * administrative exclusion. The API validates this typed value against the
 * audit-note prefix before persisting it.
 */
export const getNewMemberReviewReasonCategory = (
  actionLabel: "Hold" | "Block"
): ManualNotAFitReasonCategory =>
  actionLabel === "Hold" ? "credential_review" : "administrative_block";
